<template>
  <div>
    <Griddle position="fixed"/>
    <Press v-if="Object.keys(page.reviews || {}).length" :data="page.reviews"/>
    <Scheduler :s="schedule" :t="tz" @update="e => handleScheduleUpdate(e.s, e.t)"/>
    <ErrorBoundary :errorContent="error_content" @generic-error="handleGenericError">
      <component
          v-memo="[page.$content, page.fields, page.listings]"
          v-if="page.$content"
          :is="page.$content"
          :fields="page.fields"
          :listings="page.listings"
          :theme="page.theme"
          :embedSHListing="embedSHListing"
          :initGoogleTags="initGoogleTags"
          :initJornaya="initJornaya"
          :loadChatBot="loadChatBot"
          :loadWebTrends="loadWebTrends"
          :popupImpressionTracking="popupImpressionTracking"
          :currentURL="page.url"
          class="page-context"
          :customFlow="page.customFlow"
          :loadABT="loadABT"
          :state="page.state"
          :isBackground="!!popup.$content"
      />
      <PopUp v-if="!!popup.$content" :currentURL="popup.url">
        <component
            v-memo="[popup.$content, popup.fields]"
            :is="popup.$content"
            :fields="popup.fields"
            :currentURL="popup.url"
            :loadChatBot="loadChatBot"
            class="popup-context"
            :listings="popup.listings"
            :theme="page.theme"
            :initGoogleTags="initGoogleTags"
            :loadWebTrends="loadWebTrends"
            :closePopup="closePopup"
            :initJornaya="initJornaya"
            :customFlow="popup.customFlow"
            :popupImpressionTracking="popupImpressionTracking"
            @redirectTo="redirectTo"
            :schedule="schedule"
            :loadABT="loadABT"
            :state="page.state"
            :isBackground="false"
        />
      </PopUp>
    </ErrorBoundary>
  </div>
</template>
<script>
import {compile, h, toRaw} from 'vue';
import backend from "./backend";
import ErrorBoundary from "@/components/waffle/ErrorBoundary.vue";
import Griddle from "@/components/waffle/components/Griddle.vue";
import Press from "@/components/waffle/components/Press.vue";
import {computed} from "vue";
import {getCurrentIndex} from "@/components/waffle/utils/messageTransition";
import isIvrOpen from '@/components/waffle/utils/isIvrOpen'
import Scheduler from "@/components/waffle/components/Scheduler.vue";
// eslint-disable-next-line no-unused-vars
import webtrends from "@/components/waffle/utils/webtrends";
//webtrend import is here to make sure that the iffy is ran and WT is immediately initialized

import {debounce} from "@/components/waffle/utils/debouce";

//component imports for explicit registration in dynamo
import QuestionContainer from "@/components/waffle/components/QuestionContainer.vue";
import Progressor from "@/components/waffle/components/Progressor.vue";
import PopUp from "@/components/waffle/components/PopUp.vue";
import Icon from "@/components/waffle/components/Icon.vue";
import Carousel from "@/components/waffle/components/Carousel.vue";
import Timer from "@/components/waffle/components/Timer.vue";
import SkeletonLoader from "@/components/waffle/components/presentational/SkeletonLoader.vue";
import Snackbar from "@/components/waffle/components/presentational/Snackbar.vue";
import Tooltip from "@/components/waffle/components/presentational/Tooltip.vue";
import DynamicPopover from "@/components/waffle/components/presentational/DynamicPopover.vue";
import CurrencyPresentation from "@/components/waffle/components/presentational/CurrencyPresentation.vue";

export default {
  name: 'WaffleWorld',
  components: {Scheduler, PopUp, Icon, ErrorBoundary, Griddle, Press},
  data() {
    return {
      manualPopUpClose: false,
      hasPopupMounted:false,
      previouslyTrackedValue:{},
      isAgencyOpen: true,
      callbackFired: false,
      page: {
        reviews: {},
        fields: [],
        listings: {},
        $content: '',
        url: (typeof this.$route.params.pathMatch === "string" && this.$route.params.pathMatch) ?
                  this.$route.params.pathMatch:
            (this.$route.params.pathMatch && Array.isArray(this.$route.params.pathMatch)) ?
                  this.$route.params.pathMatch.join('/') : 'start' ,
        customFlow: '',
        state: ''
      },
      popup: {
        fields: [],
        $content: '',
        url: '',
        customFlow: '',
      },
      //hard-coded templates
      error_content: ``,
      schedule: null,
      tz:null,
      schedule_content:``,
      dcsid:null,
      reloadSignal: false,
      subpathDeployment:'',
      version:null,
      WTQueue:[],
      disableScriptLoaders:false
    }
  },
  inject:['setTransition'],
  provide() {
    return {
      formSubmitted: this.formSubmitted,
      getCurrentURL: this.getCurrentURL,
      vgsSubmit:this.vgsSubmit,
      navigate: this.navigate,
      setPreviouslyTracked: updateObject => this.previouslyTrackedValue = {...this.previouslyTrackedValue, ...updateObject},
      previouslyTrackedValue:computed(() => this.previouslyTrackedValue),
      isPopUp: !!this.popup.$content,
      hasMounted: computed(() => this.hasPopupMounted) ,
      updateMounted: () => this.manualPopUpClose ? this.manualPopUpClose=false: this.hasPopupMounted = true,
      isAgencyOpen:computed(() => this.isAgencyOpen),
      openSchedulePopup: () => this.popup.$content = this.dynamo(this.schedule_content),
      componentVersion: computed(()=>this.version),
      triggerJornayaTracking: this.triggerJornayaTracking,
      registerWTQ: (cb) => this.WTQueue.push(cb)
    }
  },
  async mounted() {
    ({sid: this.sid, CLK: this.CLK} = this.$route.query);
    { //TODO syam optimize this code
      let url =(typeof this.$route.params.pathMatch === "string" && this.$route.params.pathMatch) ?
          this.$route.params.pathMatch:
          (this.$route.params.pathMatch && Array.isArray(this.$route.params.pathMatch)) ?
              this.$route.params.pathMatch.join('/') : 'start'

      let fallback_content;
      let ivrSchedule;
      window.addEventListener('resetFields', () => {
        this.popup.fields= []
        this.page.fields = []
      })
      try{
        fallback_content = await import("../../../public/"+window.location.hostname+'/templates.js')
        ivrSchedule = await import("../../../public/"+window.location.hostname+'/ivrSchedule.js')
      }catch (e) {
        if(process.env.NODE_ENV !== 'production'){
          console.log('Dedicated fallback content file or ivrSchedule not found, if this is not a static build site, this is expected to be checked in by the developer per domain!')
        }
      }


      const isTab = this.$route.query?.tab;
      this.registerChannel()
      if( sessionStorage.getItem('waffle_tab')){
        window.channel.postMessage({type:'RELOAD'})
      }
      window.offload_counter= false;
      if(window.location.pathname.split('/')?.[1] !== 'waffle'){
        this.subpathDeployment ='/'+ window.location.pathname.split('/')?.[1];
      }
      if(isTab){
        sessionStorage.setItem('waffle_tab', true)
        const token = this.$route.query?.token;
        window.channel.postMessage({type:'RELOAD'})
        if(token){
          sessionStorage.setItem('x-waffle',token);
        }
      }
      try{
        const staticCall = await fetch(
            this.subpathDeployment + "/"+window.location.hostname+'/blurbs/'+(window.location.pathname?.split('/')?.slice(2)?.join('/')?.split(':')?.[0] || 'start') +'.json'
        )
        let blurb;

        if(staticCall.ok){
          blurb= await staticCall.json()
        }
        if(blurb?.default){
          this.disableScriptLoaders = true;

          if (this.stripURL(url).split('/').length > 2){

            const pageContent = await fetch(this.subpathDeployment+"/"+window.location.hostname+'/blurbs/'+ url?.split('/').slice(0,-1).join('/')+'.json')
            const background = await pageContent.json()

            this.handleContentUpdate({data: {content: background?.default, listings: {}, fields: [], theme:''}, config:{url: url?.split('/').slice(0).join('/')}}, 'page')
            this.handleContentUpdate({data: {content: blurb?.default, listings: {}, fields: [], theme:''}, config:{url: url?.split('/').slice(1).join('/')}}, 'popup')
          }else{
            this.handleContentUpdate({data: {content: blurb?.default, listings: {}, fields: [], theme:''}, config:{url:url?.split('/').slice(1).join('/')}}, 'page')
          }
        }
      }catch (e) {
        if(process.env.NODE_ENV !== 'production'){
          console.info('static content not found, check build files and build process in server if static content is expected')
        }
      }

      if(ivrSchedule?.default){
        this.schedule_content = fallback_content?.default?.schedule_content
        this.handleScheduleUpdate(ivrSchedule?.default?.schedule,ivrSchedule?.default?.timezone )
      }else{
        this.isAgencyOpen = true;
      }

      try{
        const errorModalCall = await fetch(this.subpathDeployment + "/"+window.location.hostname+'/blurbs/error.json')
        const c = await errorModalCall?.json()
        this.error_content = c?.default
      }catch (e) {
        if(process.env.NODE_ENV !== 'production'){
          console.log('No error blurb static content found')
          if(!fallback_content?.default?.error_content){
            console.log('No checked in file for error content was found, make sure that this is intended as it can have negative effects.')
          }
        }
        this.error_content = fallback_content?.default?.error_content ?? '<div></div>';
      }

      try {
        if (this.stripURL(url).split('/').length > 2) {
          backend.getData(this.stripURL(url).split('/').slice(0, -1).join('/'), response => {
            try{
              let redirectURL = response.data.redirectURL;
              if(response.data.status === 'FAILURE' && !response.data.fields) throw response;
              if (response.data.status === 'SUCCESS' && redirectURL)
                this.navigate(redirectURL)
              else {
                this.handleContentUpdate(response, 'page')
            }} catch (e) {
                console.log(e)
                this.popup.$content = this.dynamo(this.error_content)
                this.popup.fields= []
              }
              backend.getData(url, inlineResponse => {
                try{
                  let redirectURL = inlineResponse.data.redirectURL;
                  if(response.data.status === 'FAILURE' && !response.data.fields) throw response;
                  if (inlineResponse.data.status === 'SUCCESS' && redirectURL)
                    this.navigate(redirectURL)
                  else {
                    this.disableScriptLoaders = false
                    this.handleContentUpdate(inlineResponse, 'popup')
                  }
                }catch (e) {
                  console.log(e)
                  this.popup.$content = this.dynamo(this.error_content)
                  this.popup.fields= []
                }

              });
          });
        } else
          backend.getData(url, response => {
            try{
              this.disableScriptLoaders = false;
              let redirectURL = response.data.redirectURL;
              if(response.data.status === 'FAILURE' && !response.data.fields) throw response;
              if (response.data.status === 'SUCCESS' && redirectURL){
                this.navigate(redirectURL)
              }
              else {
                this.disableScriptLoaders = false
                this.handleContentUpdate(response, 'page')
              }
            }catch (e) {
              console.log(e)
              this.popup.$content = this.dynamo(this.error_content)
              this.popup.fields= []
            }
          });
      } catch (e) {
        console.log(e)
        this.popup.$content = this.dynamo(this.error_content)
        this.popup.fields= []
      }
    }
  },
  beforeRouteUpdate (to) {
    let url = '/' + to.href.split('/').slice(2).join('/');
    if (url.indexOf('home/coverage-items-rc2/remove') !== -1 || url.indexOf('intro/knockout') !== -1 || url.indexOf('/rates/coverages') !== -1 || url.indexOf('/confirmation/summary') !== -1) {
      backend.getData(url, inlineResponse => {
        if(inlineResponse?.data?.content){
        this.handleContentUpdate(inlineResponse, 'popup')
        }else{
          this.getStaticBlurb(url, inlineResponse?.data?.listings, inlineResponse?.data?.fields || [], inlineResponse?.data?.theme);
        }
      });
      return false;
    } else if (url.indexOf('/error') !== -1 && this.page.$content) {
      if (this.page.fields?.find(f=>f.name==='Timer'))
        window.dispatchEvent(new Event('toggle-timer'));
      backend.getData(url, inlineResponse => {
        if(inlineResponse?.data?.content){
        this.handleContentUpdate(inlineResponse, 'popup')
        }else{
          this.getStaticBlurb(url, inlineResponse?.data?.listings, inlineResponse?.data?.fields || [], inlineResponse?.data?.theme);
        }
      });
      return false;
    }
    return true;
  },
  methods: {
    closePopup: function () {
      this.manualPopUpClose = true
      this.handleContentUpdate(null, 'popup')
    },
    redirectTo: function (url) {
      backend.getData(this.getCurrentURL() + '/' + url, inlineResponse => {
        if(inlineResponse?.data?.content){
        this.handleContentUpdate(inlineResponse, 'popup')
        }else{
          this.getStaticBlurb(url, inlineResponse?.data?.listings, inlineResponse?.data?.fields || [], inlineResponse?.data?.theme);
        }      });
    },
    embedSHListing: debounce(function(containerId, _sh_listing_data_) {
      if(this.disableScriptLoaders) return;

      let scr = "sh.initialize(" + JSON.stringify(_sh_listing_data_) + ", '" + containerId + "');";
      let shelement = document.createElement('script');
      shelement.src = process.env.VUE_APP_SH_URL;
      shelement.type = 'text/javascript';
      document.body.appendChild(shelement);
      let shvarelement = document.createElement('script');
      shvarelement.appendChild(document.createTextNode(scr));
      shvarelement.type = 'text/javascript';
      shelement.addEventListener('load', function () {
        document.body.appendChild(shvarelement);
      });
      return '';
    }, 1000),
    initGoogleTags: debounce(function(GTM_ID){
      if(this.disableScriptLoaders) return;
      window.GTM_ID=GTM_ID

      if(!window.googleTagsLoaded){
        const googleTagsElement =  document.createElement('script')
        googleTagsElement.type='text/javascript';

        googleTagsElement.src = location.origin + this.subpathDeployment +'/loadGoogleTags.js';
        document.head.appendChild(googleTagsElement);
        googleTagsElement.addEventListener('load',() => {
          console.log('google tags load event finished')
        })

        const tagsTrackerIframe = document.createElement('noscript')
        const Iframe = document.createElement('iframe')
        Iframe.src="https://www.googletagmanager.com/ns.html?id=" + GTM_ID
        Iframe.style.height=0;
        Iframe.style.width=0;
        Iframe.style.display='none';
        Iframe.style.visibility='hidden';
        Iframe.allow='autoplay';
        tagsTrackerIframe.append(Iframe);
        document.body.prepend(tagsTrackerIframe)
      }
    },500),
    initJornaya: debounce(function(accountID, statusOnPageUnmount = 'active'){
      if(!accountID){
        if(process.env.NODE_ENV !== 'production'){
          console.error('Jornaya account id not passed, can not initialize.')
        }
        return
      }
      if(this.disableScriptLoaders) return;

      if(window.LeadiD && window.j_runner &&  window.LeadiD.statusOnPageUnmount === 'inactive'){
        window.LeadiD.util.api.doApiCall = window.j_runner
      }

      if(!window.LeadiD) {
        const id = document.getElementById('leadid_token')
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              if (window.Webtrends_init) {
                window.dcsMultiTrack(...[
                  [`DCSext.qse_${window.webtrendsPrefix}_position`, 'pageview_' + 'Jornaya'],
                  [`DCSext.qse_${window.webtrendsPrefix}_value`, 'pageview_'+id.value],
                  window.getWebtrendsConstants()
                ].flat());
              }  else if(!window.Webtrends_failed && !window.Webtrends_init){
                this.WTQueue.push(() => window.dcsMultiTrack([
                  [`DCSext.qse_${window.webtrendsPrefix}_position`, 'pageview_' + 'Jornaya'],
                  [`DCSext.qse_${window.webtrendsPrefix}_value`, 'pageview_'+id.value],
                  window.getWebtrendsConstants()
                ].flat()))
              }
              else if(window.Webtrends_failed){
                fetch(`/api/acquire/fallback`,{header:{contentType:'application/json'}})
              }
              this.triggerJornayaTracking()
            }
          }
        });

        observer.observe(id, {
          attributes: true,
          attributeFilter: ['value'],
        });

        var s = document.createElement('script');
        s.id = 'LeadiDscript_campaign';
        s.type = 'text/javascript';
        s.async = true;
        s.src = `//create.lidstatic.com/campaign/${accountID}.js?snippet_version=2`;
        var LeadiDscript = document.getElementById('LeadiDscript');
        LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
        s.addEventListener('load', () => {
          if (window.LeadiD) {
            window.LeadiD.statusOnPageUnmount = statusOnPageUnmount

            this.$nextTick(() => {
              if(window.LeadiD.statusOnPageUnmount === 'inactive'){
                window.j_runner = window.LeadiD.util.api.doApiCall
              }
            })
          }
        })
      }
    },1000),
    triggerJornayaTracking: function (){
      this.$nextTick(() => {
        if(window.LeadiD){
          window.LeadiD.formcapture.init()
          window.LeadiD.snap()
        }
      })
    },
    loadChatBot: debounce(function (projectID, versionID, fields, messages){
      const loadBot = () => window.voiceflow.chat.load({
        verify: { projectID },
        url: 'https://general-runtime.voiceflow.com/',
        versionID,
        userID:sessionStorage.getItem('x-waffle'),
        assistant : {
          stylesheet: `${this.subpathDeployment}/${window.location.hostname}/chatbot.css`,
        },
        launch: {
          event: {
            type: "launch",
            payload: {
              ...(fields?.find(el=> el.name === 'ChatBotDataPass')?.value ? JSON.parse(fields?.find(el=> el.name === 'ChatBotDataPass')?.value): {}),
              isMobile: this.$isMobile()
            }
          }
        }
      }).then(() => setTimeout(function() {
        window.voiceflow.chat.proactive.clear();
        if(messages?.length){
          if(Array.isArray(messages)){
            messages.forEach(message => {
              window.voiceflow.chat.proactive.push({type: 'text',payload: { message: message }});
            })
          }else{
            window.voiceflow.chat.proactive.push({type: 'text',payload: { message: messages }});
          }
        }
      },1000))
      if(!window.voiceflow){
        let scriptElem = document.createElement('script');
        let s = document.getElementsByTagName('script')[0];
        scriptElem.onload = function() {
          loadBot()
        }
        scriptElem.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs";
        scriptElem.type = "text/javascript";
        s.parentNode.insertBefore(scriptElem, s);
      }else{
        loadBot()
      }

      window.chatBotHelper = {
        pixelFire(prop, value){
          if(window.Webtrends_init && !this.disableScriptLoaders) {
            window.dcsMultiTrack(...[
              ['DCSext.' + prop, 'pageview_' + value],
              window.getWebtrendsConstants()
            ].flat());
          }
          else if(!window.Webtrends_failed && !window.Webtrends_init){
            this.WTQueue.push(() => window.dcsMultiTrack(...[
              ['DCSext.' + prop, 'pageview_' + value],
              window.getWebtrendsConstants()
            ].flat()))
          }
          else if(window.Webtrends_failed){
            fetch(`/api/acquire/fallback`,{header:{contentType:'application/json'}})
          }
        },
        proactiveMessages(type, payload){
          window.voiceflow.chat.proactive.clear();
          window.voiceflow.chat.proactive.push({type,payload});
        },
        data:{
          ...fields.reduce((acc, curr) => {
            acc[curr.name] = curr.value
            return acc;
          }, {}),
          listings: toRaw(this.page.listings)
        }
      }

    },1000),
    loadABT: debounce(function(src= "https://try.abtasty.com/85c8116cb61f03cd41882b5e39a5ec84.js"){
      const isAlreadyLoaded =  document.getElementById('tasty')
      if(!isAlreadyLoaded){
        const script = document.createElement('script');
        script.type='text/javascript';
        script.id='tasty';
        script.src=src;
        script.onload=() => console.info('AB Tasty loaded with src' + src)
        document.getElementsByTagName("head")?.[0]?.appendChild(script)
      }
    },500),
    // eslint-disable-next-line no-unused-vars
    loadWebTrends:function(dcsid='dcsg5pgfq10000s10395sh226_7h3n',dcsdomain='agencyquotesonline', flowName='', prefix='auto'){
      if(this.disableScriptLoaders) return;
      window.flowName = flowName;
      window.webtrendsPrefix = prefix;
      window.getWebtrendsConstants = ()=>[`DCSext.qse_${prefix}_flowname`,window.flowName, 'DCSext.x-waffle',sessionStorage.getItem('x-waffle')]

      this.dcsid = dcsid
      if(!window.Webtrends_init) {
        try{
          (new window.Webtrends.dcs).init({
            dcsid: dcsid,
            // domain: "www.qsstats.com",
            domain: !sessionStorage.getItem('internalWT') ? window.location.hostname + '/api/acquire' : "www.qsstats.com",
            timezone: -8,
            i18n: !0,
            onsitedoms: window.location.hostname,
            fpcdom: "." + window.location.hostname,
            plugins: {}
          }).track()
        }catch (e) {
          console.error('WT Failed to initialized')
          console.error(e)
          window.Webtrends_failed = true;
          return
        }

        this.WTQueue.forEach(cb => cb());
        this.WTQueue = [];

        window.Webtrends_init =true;
      }
    },
    popupImpressionTracking(popupVal){
      if(window.Webtrends_init && !window.blurbImpressionTracking?.[popupVal] && !this.disableScriptLoaders) {
        typeof window.blurbImpressionTracking === 'object' ? window.blurbImpressionTracking[popupVal] = true: window.blurbImpressionTracking = {[popupVal]:true}
          window.dcsMultiTrack(...[
            [`DCSext.qse_${window.webtrendsPrefix}_position`, 'pageview_' + popupVal],
            window.getWebtrendsConstants()
          ].flat());
        }else if(!window.Webtrends_failed && !window.Webtrends_init){
        this.WTQueue.push(() => window.dcsMultiTrack([
          [`DCSext.qse_${window.webtrendsPrefix}_position`, 'pageview_' + popupVal],
          window.getWebtrendsConstants()
        ].flat()))
      }else if(window.Webtrends_failed){
        fetch(`/api/acquire/fallback`,{header:{contentType:'application/json'}})
      }
    },
    dynamo: function (content) {
      { // pulled from https://developers.abtasty.com/docs/tag/tag-javascript-events#wait-to-send-transaction
        // window.abTastyDebug = true;
        const removeListeners = () => {
          window.removeEventListener('abtasty_trackingInitialized', sendTransaction);
          document.removeEventListener('abtasty_resetActionTracking', removeListeners);
        };
        const sendTransaction = () => {
          window.abtasty.send("EVENT", {
            ec: "Action Tracking",
            ea: "qsTrackClickKey",
            cv: {"0": "AB.qs_dlk," + sessionStorage.getItem('x-waffle')}
          });
          removeListeners();
        };
        if (window.ABTasty?.eventState?.trackingInitialized?.status === 'complete') {
          sendTransaction();
        } else {
          window.addEventListener('abtasty_trackingInitialized', sendTransaction);
          document.addEventListener('abtasty_resetActionTracking', removeListeners);
        }
      }

      return h({
            render: compile(content),
            components:{
              icon:Icon,
              QuestionContainer,
              PopUp,
              Progressor,
              carousel: Carousel,
              Griddle,
              Timer,
              SkeletonLoader,
              Snackbar,
              Tooltip,
              DynamicPopover,
              CurrencyPresentation
            },
            data(){
              return {
                themePhone: null,
                stash:null
              }
            },
            methods:{
              setThemePhone(config, customFlow){
                  this.themePhone = config[this.theme] ?? config[customFlow] ?? config.default;
              },
              getCurrentIndex(incr) {
                return getCurrentIndex(incr)
              },
              setTabTitleImage(imageLocation, titleText){
                const title = document.getElementById('title')
                const favIcon = document.getElementById('favicon')
                favIcon.href=imageLocation;
                title.textContent= titleText;
              },
              ctaPixelFire: debounce(function (config1, value1, config2, value2) {
                if(window.Webtrends_init && !this.disableScriptLoaders) {
                  window.dcsMultiTrack(...[
                  ['DCSext.' + config1,  value1],
                  ['DCSext.' + config2, value2],
                    window.getWebtrendsConstants()
                  ].flat());
                }else if(!window.Webtrends_failed && !window.Webtrends_init){
                  this.WTQueue.push(() => window.dcsMultiTrack([
                    ['DCSext.' + config1,  value1],
                    ['DCSext.' + config2, value2],
                    window.getWebtrendsConstants()
                  ].flat()))
                }else if(window.Webtrends_failed){
                  fetch(`/api/acquire/fallback`,{header:{contentType:'application/json'}})
                }
              }, 500),
            },
            inject:['getCurrentURL', 'isAgencyOpen','openSchedulePopup','setTransition'],
        props: ['fields', 'loadChatBot','listings', 'embedSHListing', 'closePopup','initGoogleTags','loadWebTrends','popupImpressionTracking','theme','schedule', 'initJornaya','customFlow', 'loadABT','isBackground', 'state'],
        provide(){
          return {
            isBackdrop: computed(() =>  this.isBackground),
          }
        }}
      );
    },
    getCurrentURL: function (location) {
      return !location ?  (this.popup.$content ? this.popup.url : this.page.url) : this[location]?.url;
    },
    stripURL: function (url) {
      return url.replace(/^\/+|\/+$/g, '');
    },
    handleGenericError(response) {
      this.handleContentUpdate(response, 'popup')
    },
    handleContentUpdate(response, context) {
      //TODO syam use 'watch:' to trigger the updates on url/$content with 'immediate: true'
      if(!response){
        this[context].$content = ''
        this[context].fields = ''
      } else{
        const clkFound = response.data.fields.find(el => el.name === 'CLK')
        if(clkFound){
          this.CLK = clkFound.value;
        }

        this[context].$content = response.data.content ?  this.dynamo(response.data.content ):this[context].$content
        this[context].reviews = response.data.reviews
        this[context].fields = response.data.fields
        this[context].listings = response.data.listings
        this[context].theme = response.data.theme;
        this[context].state = response.data.state;
        this[context].url = response.config?.url?.split('/')?.filter(f => f)?.join("/");
        this[context].customFlow = response.data?.customFlow
        this.version = response.data?.version;
      }
    },
    registerChannel(){
      if(!window.channel){
        window.channel = new BroadcastChannel('waffle_channel')
        window.addEventListener("focus", () => {
          if(sessionStorage.getItem('waffle_tab')) return;
          if(this.reloadSignal){
            this.$router.go()
            this.reloadSignal =false;
          }
        });
        window.channel.onmessage = (e) => {
          switch(e.data.type){
            case 'REDIRECT':{
              this.setTransition()
              return this.$router.push(e.data.to);
            }
            case 'RELOAD':{
              return this.reloadSignal = true
            }
          }
        }
      }
    },
    navigate(redirectUrl){
      if(redirectUrl[0]?.includes('http')){
        return location.replace(redirectUrl[0])
      }
      let to = '/'+this.$route?.path?.split('/')[1] + redirectUrl[0]

      //TODO syam pls find a better solution as router isn't resetting component if same path
      if ((''+this.$route.href) === to)
        window.location.reload();
      else {
        if (this.page.url.endsWith('-loading'))
          this.$router.replace(to);
        else
          this.setTransition()
          this.$router.push(to);
      }
      const tabURLS = redirectUrl.slice(1)
      if(window.ffTabs && tabURLS?.length){
        tabURLS.forEach((url) => {
            window.ffTabs.forEach(tab => {
              tab.location='/'+this.$route?.path?.split('/')[1] + url+'?tab=true&token='+sessionStorage.getItem('x-waffle')
            })
            window.ffTabs = null;
        })
      }else if(tabURLS?.length){
        tabURLS.forEach((url) => {
            const a = document.getElementById('lbTrigger')
            a.href = '/'+this.$route?.path?.split('/')[1]+ url+'?tab=true&token='+sessionStorage.getItem('x-waffle')
            a.target = "_blank"
            a.click()
        })
      }
    },
    async handleResponse(response){

      let redirectURL = response.data.redirectURL;
      if(redirectURL){
        this.previouslyTrackedValue = {}
      }
      let isPopUp
      const currentLocation = (this.stripURL(this.getCurrentURL()) + '/')?.split('/')?.slice(0,2)
      switch (response.data.status) {
        case 'SUCCESS':
/*
          if (response.data.fields?.find(f => f.name === 'PC')) //TODO syam generalize this between page/popup
            this.page.fields = response.data.fields;
*/
          isPopUp =  redirectURL ? ((redirectURL[0] === this.getCurrentURL()) ||
              (this.stripURL((redirectURL[0]) + '/')
                  ?.split('/').length > 2 &&
                      this.stripURL((redirectURL[0]) + '/')
                          ?.split('/')
                          ?.slice(0,2)
                          .every((el,i)=> currentLocation[i] === el) )): false

          if (isPopUp) {
            const staticCall = await fetch(
                this.subpathDeployment+"/"+window.location.hostname+'/blurbs/'+redirectURL[0]+'.json'
            )
            let blurb;

            try{
              if(staticCall.ok){
                blurb= await staticCall.json()
              }
            }catch (e) {
              if(process.env.NODE_ENV !== 'production'){
                console.error('static content not found, check build files and build process in server if static content is expected')
              }
            }


            backend.getData(redirectURL[0], inlineResponse => {
              try {
                inlineResponse.data.redirectURL ? this.handleResponse(inlineResponse) : this.handleContentUpdate(blurb?.default ? {
                  ...inlineResponse,
                  data: {...inlineResponse.data, content: blurb.default}
                } : inlineResponse, 'popup');
              } catch (e) {
                console.log(e)
                this.popup.$content = this.dynamo(this.error_content)
                this.popup.fields= []
              }
            });
          } else {
            this.navigate(redirectURL)
          }
          break;
        case 'FAILURE':
          isPopUp = Boolean(this.popup.$content)
          if (response.data.errorMessage)
            throw new Error(response.data.errorMessage);
          else if(isPopUp){
            if (response.data.fields)
              this.popup.fields = response.data.fields;
          }else{
            if (response.data.fields)
              this.page.fields = response.data.fields;
          }
      }
    },
    formSubmitted: function (formValues) {
      if (this.sid) {
        //TODO post route.params as query-string to server so backend can process them as a 'post' (get+params)
        formValues.fields.push({field_name: "sid", field_value: this.sid});
        formValues.fields.push({field_name: "CLK", field_value: this.CLK});
      }
      // sending leadid token to backend when generated
      if(window.LeadiD?.token){
        formValues.fields.push({field_name: "leadid_token", field_value: window.LeadiD.token})
      }
      //TODO propagate question.type=link so we don't hardcode this
      let link = formValues.fields.find(f => f.field_name === 'VehicleList' || f.field_name === 'DriverList' || f.field_name === 'ApplicantList');
      if (link) {
        this.$router.push(link.field_value);
        return;
      }
      //TODO show skeleton screen with a message carousel
        backend.postData(this.getCurrentURL(), formValues, response => {
          try{
            this.handleResponse(response)
          }catch (e) {
            console.log(e)
            this.popup.$content = this.dynamo(this.error_content)
            this.popup.fields= []
          }
        });
    },
    vgsSubmit(formValues, formObject) {
      const vgsFormObj = toRaw(formObject);

        const headersFromAxios = { Pragma: 'no-cache', Client: 'pemco', 'x-waffle' : sessionStorage.getItem("x-waffle") ,'X-Frame-Options': 'SAMEORIGIN', 'X-XSS-Protection': '1; mode=block' };

        const formData = {
          ...formValues, //[{field_name:'bankaccount',field_value:''}]
        };

          if (vgsFormObj && vgsFormObj.submit) {
            vgsFormObj.submit('/api/waffle/' + this.getCurrentURL(), {
              data: formData,
              mapDotToObject: 'mergeArray',
              headers: {...headersFromAxios},
            },
            (status, response) => {
              response?.redirectURL && !Array.isArray(response.redirectURL) && (response.redirectURL = [response.redirectURL])
              if (status < 400) {
                this.handleResponse({data:response})
              } else {
                console.warn(status, response)
                this.popup.$content = this.dynamo(this.error_content)
                this.popup.fields= []
              }
            },
            error => {
              console.log(error)
              this.popup.$content = this.dynamo(this.error_content)
              this.popup.fields= []
            });
          } else {
            this.popup.$content = this.dynamo(this.error_content)
            this.popup.fields= []
            console.log('VGS form is undefined');
          }

    },
    triggerPageView(){
      this.$nextTick(()=>{
        const sendClk = this.CLK ? ['DCSext.CLK', this.CLK]:[]
        const url = this.getCurrentURL()?.[0] === '/' ? '/waffle'+ this.getCurrentURL():'/waffle/'+ this.getCurrentURL()

        if(window.Webtrends_init) {
          window.dcsMultiTrack(`DCSext.qse_${window.webtrendsPrefix}_url`, url, ...sendClk ,...window?.getWebtrendsConstants() ?? []);
        }else if(!window.Webtrends_failed && !window.Webtrends_init){
          this.WTQueue.push(() => window.dcsMultiTrack(...[`DCSext.qse_${window.webtrendsPrefix}_url`, url, ...sendClk ,...window?.getWebtrendsConstants() ?? []]))
        }else if(window.Webtrends_failed){
          fetch(`/api/acquire/fallback`,{header:{contentType:'application/json'}})
        }
      })
    },
    async getStaticBlurb(url, listings = {}, fields = [], theme = '') {
      const staticCall = await fetch(
          this.subpathDeployment + "/" + window.location.hostname + '/blurbs/' + (url?.split('/')?.slice(1)?.join('/')?.split(':')?.[0] || 'start') + '.json'
      )
      let blurb;

      if (staticCall.ok) {
        blurb = await staticCall.json()
      }
      if (blurb?.default) {
        this.disableScriptLoaders = true;

        if (this.stripURL(url).split('/').length > 2 || url.indexOf('error') > -1) {
          this.handleContentUpdate({
            data: {content: blurb?.default, listings, fields, theme},
            config: {url: url?.split('/').slice(1).join('/')}
          }, 'popup')
        } else {
          this.handleContentUpdate({
            data: {content: blurb?.default, listings, fields, theme},
            config: {url: url?.split('/').slice(1).join('/')}
          }, 'page')
        }
      }
    },
    handleScheduleUpdate(schedule, tz){
      this.isAgencyOpen = isIvrOpen(tz, schedule)
      this.schedule = schedule
      this.tz = tz
    }
  },
  watch:{
    'page.fields':{
      handler(val){
        if(val?.length){
          this.triggerPageView()
          this.triggerJornayaTracking()
      }
    }
    },
    'popup.fields':{
      handler(val){
        if(val?.length){
          this.triggerPageView()
          this.triggerJornayaTracking()
        }
      }
    },
  },
  unmounted() {
    if(window.msgIdx){
      window.msgIdx = 0;
    }
    if(window.LeadiD && window.LeadiD?.util?.api?.doApiCall && window.LeadiD.statusOnPageUnmount === 'inactive'){
        window.LeadiD.util.api.doApiCall = function(){}
    }
    if(window.voiceflow){
      window.voiceflow.chat.destroy()
    }
  }
}
</script>
<style lang="scss" src="../../../src/assets/scss/waffle.scss">
</style>
